import useScreenMode from '../../Hooks/useScreenMode';
import ResponsiveWorkspaceLayout from '../../Layout/ResponsiveWorkspaceLayout';
import BolMobileList from './BolMobileList';
import BolPagination from './BolPagination';
import BolTable from './BolTable';
import BolTopBar from './BolTopBar';

type Props = {
    data: any[];
    columns: any[];

    pagination: {
        page: number;
        total: number;
        totalRows?: number;
    };
    setPagination: React.Dispatch<React.SetStateAction<any>>;

    search?: string;
    setSearch?: (value: string) => void;

    allowLocation?: boolean;
    dcLocation?: string;
    onLocationChange?: (value: string) => void;

    showFilterButton?: boolean;
    onOpenFilter?: () => void;

    showCreateButton?: boolean;
    onOpenCreate?: () => void;
    createLabel?: string;

    onEdit?: (row: any) => void;
    rowActions?: (row: any) => React.ReactNode;

    topBarExtraActions?: React.ReactNode;
    bottomLeftSlot?: React.ReactNode;
    bottomRightSlot?: React.ReactNode;

    getRowSx?: (row: any) => Record<string, any>;
    getCardSx?: (row: any) => Record<string, any>;

    showResetButton?: boolean;
    onResetFilters?: () => void;
    resetLabel?: string;

    emptyMessage?: string;
    showTotalRows?: boolean;
};

export default function BolWorkspace({
    data,
    columns,

    pagination,
    setPagination,

    search = '',
    setSearch,

    allowLocation = true,
    dcLocation = 'All',
    onLocationChange,

    showFilterButton = true,
    onOpenFilter,

    showCreateButton = true,
    onOpenCreate,
    createLabel = 'Create BOL',

    onEdit,
    rowActions,

    topBarExtraActions,
    bottomLeftSlot,
    bottomRightSlot,

    getRowSx,
    getCardSx,

    showResetButton = false,
    onResetFilters,
    resetLabel = 'Reset',

    emptyMessage = 'No records found.',
    showTotalRows = true,
}: Props) {
    const screen = useScreenMode();

    return (
        <ResponsiveWorkspaceLayout
            topBar={
                <BolTopBar
                    search={search}
                    onSearchChange={setSearch}
                    allowLocation={allowLocation}
                    locationValue={dcLocation}
                    onLocationChange={onLocationChange}
                    showFilterButton={showFilterButton}
                    onOpenFilter={onOpenFilter}
                    showCreateButton={showCreateButton}
                    onOpenCreate={onOpenCreate}
                    createLabel={createLabel}
                    extraActions={topBarExtraActions}
                    showResetButton={showResetButton}
                    onResetFilters={onResetFilters}
                    resetLabel={resetLabel}
                />
            }
            content={
                screen.useCardView ? (
                    <BolMobileList
                        data={data}
                        onEdit={onEdit}
                        rowActions={rowActions}
                        getCardSx={getCardSx}
                    />
                ) : (
                    <BolTable
                        data={data}
                        columns={columns}
                        onEdit={onEdit}
                        rowActions={rowActions}
                        getRowSx={getRowSx}
                        emptyMessage={emptyMessage}
                    />
                )
            }
            bottomBar={
                <BolPagination
                    page={pagination.page}
                    total={pagination.total}
                    totalRows={pagination.totalRows}
                    showTotalRows={showTotalRows}
                    onPageChange={(page) =>
                        setPagination((prev: any) => ({
                            ...prev,
                            page,
                        }))
                    }
                    leftSlot={bottomLeftSlot}
                    rightSlot={bottomRightSlot}
                />
            }
        />
    );
}